import React from 'react';
import { gql } from '@apollo/client';
import { TextField, BooleanField, Show, SimpleShowLayout, FunctionField } from 'react-admin';
import TimestampFields from 'components/TimestampFields';
import ReviewLink from './ReviewLink';
import LinkField from 'components/LinkField';

const ReviewShow = () => (
  <Show>
    <SimpleShowLayout>
      <TextField label="ID" source="id" />
      <FunctionField
        label="Reviewer"
        render={({ reviewer_type, reviewer_id }) =>
          ReviewLink({ model: reviewer_type, id: reviewer_id })
        }
      />
      <LinkField label="Location ID" source="job.location.id" />
      <FunctionField
        label="Reviewee"
        render={({ reviewee_type, reviewee_id }) =>
          ReviewLink({ model: reviewee_type, id: reviewee_id })
        }
      />
      <LinkField label="Job ID" source="job.id" />
      <TextField label="Comments" source="comments" />
      <TextField label="Rating" source="rating" />
      <BooleanField label="Blocked" source="blocked" />
      <TimestampFields />
    </SimpleShowLayout>
  </Show>
);

ReviewShow.query = gql`
  query review($id: Int!) {
    review(id: $id) {
      blocked
      comments
      created_at
      id
      job {
        id
        location {
          id
        }
      }
      rating
      reviewee_id
      reviewee_type
      reviewer_id
      reviewer_type
      updated_at
    }
  }
`;

export default ReviewShow;
